module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAKCAYAAACNMs+9AAAAOUlEQVQYGY3BQQkAIBQFwV0wiIGMayCDfFCP4unNSEhCEpKQhORTa26u1oc85FNrbq7WhzwkJCEJHTOkCAvmmF4sAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/flappybird/blink_00.png
// module id = 193
// module chunks = 0